import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { tokenEmailApi as API } from '../Apis';

export const SendTokenEmailDocs: IDocs = {
  title: 'SendTokenEmail',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.sendTokenEmail',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.post({ type: stateRequestParameters.tokenType });

export const SendTokenEmailMachine = GenericMachine(prepareCall, {
  docs: SendTokenEmailDocs,
  definitions: API.definitions,
});
